import React from 'react';
import { useHistory } from 'react-router';
import { useTranslation } from '../../contexts/translation';
import { Columns } from '../../pages/CustomerProjects/Columns';
import { SisDataGrid } from '../table';
import { IDataGrid } from './AssetsDataGrid';

interface CustomerProjectsIDataGrid extends IDataGrid {
  customerId: number;
}

export const CustomerProjectsDataGrid = ({
  data,
  handleEdit,
  customerId,
}: CustomerProjectsIDataGrid) => {
  const { translate } = useTranslation();
  const transFormName = 'CustomerProject.List';
  const history = useHistory();

  const onToolbarPreparing = (e) => {
    e.toolbarOptions.items.unshift(
      {
        location: 'before',
        html: translate!('Projects', transFormName),
      },
      {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'add',
          type: 'default',
          stylingMode: 'contained',
          onClick: () => {
            history.push({
              pathname: `/customers-projects/new/`,
              state: { customerId: customerId },
            });
          },
        },
      },
    );
  };
  return (
    <SisDataGrid
      data={data}
      keyExpr={'id'}
      transFormName={transFormName}
      columns={Columns(handleEdit, translate)}
      onCellDblClick={(e) => handleEdit && handleEdit(e)}
      columnChooser={false}
      allowColumnResizing={false}
      allowColumnReordering={false}
      onToolbarPreparing={onToolbarPreparing}
    />
  );
};
